import request from '@/utils/request'

// 查询属性信息列表分页
export function fetchList(query) {
    return request({
        url: '/fix/06d920ee1458ee7f28993a32157453cb/page',
        method: 'get',
        params: query,
    })
}
// 查询属性信息列表不分页
export function devList(query) {
    return request({
        url: '/fix/06d920ee1458ee7f28993a32157453cb/public/page',
        method: 'get',
        params: query,
    })
}
// 查询属性详细
export function getObj(id) {
    return request({
        url: '/fix/06d920ee1458ee7f28993a32157453cb/detail?id=' + id,
        method: 'get',
    })
}
// 新增属性
export function addObj(data) {
    return request({
        url: '/fix/06d920ee1458ee7f28993a32157453cb/add',
        method: 'post',
        data: data,
    })
}

// 修改属性
export function putObj(data) {
    return request({
        url: '/fix/06d920ee1458ee7f28993a32157453cb/edit',
        method: 'post',
        data: data,
    })
}
// 删除属性
export function delObj(data) {
    return request({
        url: '/fix/06d920ee1458ee7f28993a32157453cb/delete',
        method: 'post',
        data: data,
    })
}
